import { render, staticRenderFns } from "./Medewerkers.vue?vue&type=template&id=638420b4&scoped=true"
import script from "./Medewerkers.vue?vue&type=script&lang=ts"
export * from "./Medewerkers.vue?vue&type=script&lang=ts"
import style0 from "./Medewerkers.vue?vue&type=style&index=0&id=638420b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638420b4",
  null
  
)

export default component.exports